/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import {
  buttonStyle,
  disabledRootStyle,
  errorRootStyle,
  rootStyle,
} from "./amountStyles";
import { useAmount } from "./useAmount";

import type { AmountProps } from "./amountProps";
import type { FcWithoutChildren } from "types/fcWithoutChildren";

export const Amount: FcWithoutChildren<AmountProps> = (props) => {
  const { amount, isDisabled, isError, onAmountDecrement, onAmountIncrement } =
    props;
  const { handleAmountChange } = useAmount(props);
  const rootStyles = [
    rootStyle,
    isDisabled && disabledRootStyle,
    isError && errorRootStyle,
  ];

  return (
    <div css={rootStyles}>
      <button
        css={buttonStyle}
        disabled={isDisabled}
        onClick={onAmountDecrement}
      >
        -
      </button>
      <input
        disabled={isDisabled}
        name="amount"
        type="text"
        value={amount}
        onChange={handleAmountChange}
      />
      <button
        css={buttonStyle}
        disabled={isDisabled}
        onClick={onAmountIncrement}
      >
        +
      </button>
    </div>
  );
};
